import { render } from "./record.vue?vue&type=template&id=09d9f4d5&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=09d9f4d5&scoped=true&lang=css"
import "./record.vue?vue&type=style&index=1&id=09d9f4d5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09d9f4d5"

export default script